<template>
  <v-menu v-model="menu" top :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-hover v-slot="{ hover }">
        <v-sheet
          v-on="on"
          rounded
          width="100%"
          height="100%"
          :color="hover ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.05)'"
          style="cursor: pointer;"
        >
          <div class="pa-3" style="width: 100%;">
            <v-row no-gutters>
              <span class="item-title font-weight-medium mb-1">{{
                item.name
              }}</span>
            </v-row>
            <v-row
              align="center"
              justify="space-between"
              no-gutters
              v-if="item.sales_target !== null"
            >
              <span class="item-text">Par ventes de</span>
              <span class="item-text font-weight-bold"
                >{{ item.sales_target | round2 }}$</span
              >
            </v-row>
            <v-row
              align="center"
              justify="space-between"
              no-gutters
              v-if="item.sales_target !== null"
            >
              <span class="item-text">Quantité minimum</span>
              <span
                class="item-text font-weight-bold"
                v-if="item.quantity > 0"
                >{{ item.quantity_min | round2 }}</span
              >
            </v-row>
            <v-row align="center" justify="space-between" no-gutters>
              <span class="item-text" v-if="item.sales_target !== null"
                >Quantité selon ventes</span
              >
              <span class="item-text" v-else>Quantité pour la journée</span>
              <span
                class="item-text font-weight-bold"
                v-if="item.quantity > 0"
                >{{ item.quantity | round2 }}</span
              >
            </v-row>
          </div>
        </v-sheet>
      </v-hover>
    </template>
    <v-card>
      <v-card-text>
        <v-row align="center" no-gutters>
          <span class="item-text mb-1"> {{ item.name }}</span>
        </v-row>
        <v-row align="center">
          <v-col v-if="item.sales_target !== null" cols="12" sm="6">
            <j-decimal-input
              filled
              hide-details
              unit-suffix
              class="no-before my-1"
              label="Quantité minimum"
              @input="v => $emit('update:quantity_min', v)"
              v-model="item.quantity_min"
              :suffix="getUnit"
            ></j-decimal-input>
          </v-col>
          <v-col cols="12" :sm="item.sales_target !== null ? 6 : 12">
            <j-decimal-input
              filled
              hide-details
              unit-suffix
              class="no-before my-1"
              :label="
                item.sales_target !== null
                  ? 'Quantité selon les ventes'
                  : 'Quantié pour la journée'
              "
              v-model="item.quantity"
              :suffix="getUnit"
            ></j-decimal-input>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProductPreparationSlipItem",
  props: {
    item: {
      required: true
    },
    recipe: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getRecipes"]),
    getUnit() {
      if (this.recipe.data && this.recipe.data.use_conversion_formula) {
        return this.recipe.data.unite_inventory;
      } else {
        return this.recipe.unite_produite;
      }
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    changeHandler() {
      this.item.isChanged = true;
    }
  },
  watch: {
    item: {
      deep: true,
      handler: "changeHandler"
    }
  }
};
</script>

<style scoped>
.item-title {
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: bold;
}
.item-text {
  text-transform: uppercase;
  font-size: 0.75rem;
}
</style>
